import { filterObjectTypes } from 'stores/Deal/DealSidebarStore/filterObjects';

export const defaultObjectsFilter = {
  ...filterObjectTypes.reduce((acc, objectType) => ({ ...acc, [objectType]: true }), {}),
  canceled: false,
};
